/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Keen_Hawk_ScanInputs */

const en_bold_keen_hawk_scan = /** @type {(inputs: Bold_Keen_Hawk_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configured`)
};

const de_bold_keen_hawk_scan = /** @type {(inputs: Bold_Keen_Hawk_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfiguriert`)
};

/**
* | output |
* | --- |
* | "Configured" |
*
* @param {Bold_Keen_Hawk_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_keen_hawk_scan = /** @type {((inputs?: Bold_Keen_Hawk_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Keen_Hawk_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_keen_hawk_scan(inputs)
	return de_bold_keen_hawk_scan(inputs)
});